<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="merchantUsersRoles">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">Users and Roles</div>
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-primary float-right"
            *ngIf="isMerchantActive()"
            (click)="
              openModal(userEditType.add, 'Add User and Roles', undefined)
            "
          >
            <span>
              <fa-icon [icon]="faPlus"></fa-icon>
            </span>
            Add Users and Roles
          </button>
        </div>
      </legend>

      <p *ngIf="!merchantUsersRoles || merchantUsersRoles.length == 0">
        No roles have been added.
      </p>

      <div id="usersDetail">
        <table
          class="table table-striped table-hover table-condensed"
          *ngIf="merchantUsersRoles.length > 0"
        >
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name</th>
              <th>User Roles</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let user of merchantUsersRoles;
                let indexOfElement = index
              "
            >
              <td>
                {{ user.practicestaffId }}
              </td>
              <td>
                {{ user.userName }}
              </td>
              <td>
                <span *ngFor="let role of user.roles; let isLast = last">
                  <span *ngIf="role !== 'USER'"
                    >{{ role | roleLabel }}{{ isLast ? "" : ", " }}</span
                  >
                </span>
              </td>
              <td>
                <div class="float-right">
                  <button
                    class="btn btn-primary btn-xs mr-1"
                    *ngIf="isMerchantActive()"
                    (click)="
                      openModal(
                        userEditType.edit,
                        'Update User and Roles',
                        user,
                        indexOfElement
                      )
                    "
                  >
                    <span>
                      <fa-icon [icon]="faEditPencil"></fa-icon>
                    </span>
                    Update
                  </button>
                  <button
                    class="btn btn-danger btn-xs"
                    (click)="
                      openModal(
                        userEditType.remove,
                        'Remove User and Roles',
                        user,
                        indexOfElement
                      )
                    "
                  >
                    <span class="oi oi-x"></span>
                    Remove
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </div>
</div>
